import loadTrackingIds from '../../api/organization/load-tracking-ids';
import { canUseEditor } from '../../selectors/view/permissions';

const loadTrackingIdsIfEditor = view => dispatch =>
  canUseEditor({ view }) ? dispatch(loadTrackingIds()) : Promise.resolve();

export default loadTrackingIdsIfEditor;
